import { render, staticRenderFns } from "./SadEmoji.vue?vue&type=template&id=0bc19b40"
import script from "./SadEmoji.vue?vue&type=script&lang=js"
export * from "./SadEmoji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports